import { render, staticRenderFns } from "./class-management-page.html?vue&type=template&id=16334179&"
import script from "./class-management-page.ts?vue&type=script&lang=ts&"
export * from "./class-management-page.ts?vue&type=script&lang=ts&"
import style0 from "./class-management-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports